import { createContext } from "react";

type ToastType = "success" | "negative" | "info";

export interface ToastValue {
  type: ToastType;
  text: string;
}

export interface ToastsContextValue {
  toastsState: ToastValue[];
  showToast: (toast: ToastValue) => void;
  showGenericErrorToast: () => void;
  clearToasts: () => void;
  dismissToast: (toast: ToastValue) => void;
  showErrorToast: (text: string) => void;
}

export const ToastsContext = createContext<ToastsContextValue | undefined>(undefined);
